import { render, staticRenderFns } from "./HoleList.html?vue&type=template&id=0823fd14&scoped=true&external"
import script from "./HoleList.vue?vue&type=script&lang=js"
export * from "./HoleList.vue?vue&type=script&lang=js"
import style0 from "./HoleList.scss?vue&type=style&index=0&id=0823fd14&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823fd14",
  null
  
)

export default component.exports